<template>
  <div v-if="this.category && category.productgroups.length > 0">
    <div class="ticket-group">
      <h3 class="ticket-toggle-main-tit">{{ category.passgroup_name }}</h3>
      <popup-product-groups v-for="(data, index) in this.category.productgroups" :key="index"
                            :productGroups="data"
                            :categoryNum="categoryNum"
                            :productGroupNum="index"
                            :passgroup-type="category.passgroup_type"
                            :contentId="contentId"
                            :contentType="contentType"
                            :package-detail-map="packageDetailMap"
                            :current-index="currentIndex"/>

    </div>
  </div>
</template>

<script>
import PopupProductGroups from '@/components/voucher/PopupProductGroups'
import cookie from '@/common/utils/cookie'
import constant from '@/common/resources/constant'
import { setNumberCommas } from '@/common/utils/common'
import _ from 'lodash'

export default {
  components: {
    PopupProductGroups
  },
  props: {
    category: {
      type: Object,
      required: true
    },
    packageDetailMap: {
      type: Object
    },
    categoryNum: {
      type: Number,
      required: true
    },
    voucherType: {
      type: String,
      required: true
    },
    contentId: {
      type: String
    },
    contentType: {
      type: String
    },
    currentIndex: {
      type: String
    }
  },
  data () {
    return {
      type: 'voucher'
    }
  },
  computed: {
    isShow () {
      return this.category
    }
  },
  methods: {
    topVoucherConcurrency (index) {
      if (this.category.productgroups.length &&
        this.category.productgroups[index].products.length &&
        this.category.productgroups[index].products[0].concurrency.length) {
        return this.category.productgroups[index].products[0].concurrency[0]
      }
      return 0
    },
    topVoucherTitle (index) {
      if (this.category.productgroups && this.category.productgroups[index]) {
        return this.category.productgroups[index].productgroup_name
      }
      return ''
    },
    topVoucherDescription (index) {
      if (this.category.productgroups && this.category.productgroups[index]) {
        return this.category.productgroups[index].description
      }
      return ''
    },
    topVoucherPrice (index) {
      if (this.topVoucherConcurrency(index)) {
        let amount = this.topVoucherConcurrency(index).amount
        return setNumberCommas(amount)
      }
      return ''
    },
    topVoucherUseDay (index) {
      if (this.topVoucherConcurrency(index)) {
        return this.topVoucherConcurrency(index).use_day
      }
      return ''
    },
    clickPurchase (index) {
      if (this.topVoucherConcurrency(index)) {
        let locationOrign = window.location.origin
        if (!locationOrign) {
          locationOrign = window.location.protocol + '//' + window.location.hostname
        }
        let returnUrl = locationOrign + '/callback.html?action=ClosePopupAndReload'

        window.location.href = constant.URL_BILLING_PAYMENT +
          '?credential=' + encodeURIComponent(cookie.getCredential()) +
          '&productId=' + encodeURIComponent(this.topVoucherConcurrency(index).productid) +
          '&productType=all' +
          '&returnUrl=' + encodeURIComponent(returnUrl) +
          (this.contentType ? '&contentType=' + encodeURIComponent(this.contentType) : '') +
          (this.contentId ? '&contentid=' + encodeURIComponent(this.contentId) : '') +
          '&deviceTypeId=pc&marketTypeId=generic&partnerUserKey='
      }
    }
  },
  created () {
    this.type = _.get(this.$route, ['query', 'type'], 'voucher')
  }
}
</script>
